import { render, staticRenderFns } from "./CompoundCreateModal.vue?vue&type=template&id=1ddf85f9&scoped=true"
import script from "./CompoundCreateModal.vue?vue&type=script&lang=js"
export * from "./CompoundCreateModal.vue?vue&type=script&lang=js"
import style0 from "./CompoundCreateModal.vue?vue&type=style&index=0&id=1ddf85f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf85f9",
  null
  
)

export default component.exports